import { env } from '@edge/env'

export const DWT_WEBTWAIN_ID = 'DWT_WEBTWAIN_ID' as const
/** May be base64 encoded */
const dwtKey = env.REACT_APP_DWT_KEY
export const DWT_PRODUCT_KEY = env.REACT_APP_DWT_KEY_ENCODED ? window.atob(dwtKey) : dwtKey
export const DWT_RESOURCES_PATH = '/dwt-resources' as const
